import {
  GET_ALL_SERVICES,
  SET_ALL_SERVICES,
  GET_TIME_SLOTS,
  SET_TIME_SLOTS,
  SET_EMPLOYEE_SELECTED,
  BOOK_CUSTOMER_APPOINTMENT,
  SET_CONFIRMATION_PAGE,
  GET_ALL_IDS,
  BOOK_APPOINTMENT_RESET,
} from "../constants/ActionTypes";

export const getAllServices = id => ({
  type: GET_ALL_SERVICES,
  id,
});

export const setAllServices = payload => ({
  type: SET_ALL_SERVICES,
  payload,
});

export const getTimeSlots = payload => ({
  type: GET_TIME_SLOTS,
  payload,
});

export const setTimeSlots = payload => ({
  type: SET_TIME_SLOTS,
  payload,
});

export const setEmployeeSelected = payload => ({
  type: SET_EMPLOYEE_SELECTED,
  payload,
});
export const bookCustomerAppointment = payload => ({
  type: BOOK_CUSTOMER_APPOINTMENT,
  payload,
});

export const setConfirmationPage = payload => ({
  type: SET_CONFIRMATION_PAGE,
  payload,
});

export const getIDs = id => ({
  type: GET_ALL_IDS,
  id,
});

export const bookAppointmentReset = payload => ({
  type: BOOK_APPOINTMENT_RESET,
  payload,
});



// WEBPACK FOOTER //
// ./actions/BookAppoointment.js